export type AlertLevel = "Passed" | "Warning" | "Alert" | "Error";

interface AlertCounts {
  alertCount?: number | null;
  warningCount?: number | null;
  passedCount?: number | null;
  flwAlertCount?: number | null;
  flwWarningCount?: number | null;
  flwPassedCount?: number | null;
}

// Overall status is the worst of the flaw and FLW deviation gauges: an alert or
// warning on either flags the inspection.
export function deriveAlertLevel(inspection: AlertCounts | null | undefined): AlertLevel {
  if (!inspection) return "Error";
  if ((inspection.alertCount ?? 0) + (inspection.flwAlertCount ?? 0) > 0) return "Alert";
  if ((inspection.warningCount ?? 0) + (inspection.flwWarningCount ?? 0) > 0) return "Warning";
  if ((inspection.passedCount ?? 0) + (inspection.flwPassedCount ?? 0) > 0) return "Passed";
  return "Error";
}

export function getSessionAlertLevel(
  session: { status: string; inspection?: AlertCounts | null },
): AlertLevel {
  if (session.status === 'Failed') return "Error";
  if (!session.inspection) return "Passed";
  return deriveAlertLevel(session.inspection);
}
